import { withSchema } from '@websolutespa/bom-core';
import React from 'react';
import styled, { css } from 'styled-components';
import { UIStyledComponentProps } from '../../components/types';
import { getCssResponsive } from '../../components/utils';
import { Variant, Variants, getVariant } from '../../variants';

const variants: Variants = {
  default: css`
`,
  alfa: css`
`,
  beta: css`
`,
  gamma: css`
`,
  delta: css`
`,
};

type Props = {
  type?: Variant;
};

export type NavProps = UIStyledComponentProps<Props, 'ul'>;

const NavUl = styled.ul<NavProps>`
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  ${props => getVariant(props.type, variants)}
  ${props => getCssResponsive(props, { gap: '0.6rem' })}
`;

const NavLi = styled.li<NavProps>`
  padding: 0;
`;

const NavRow: React.FC<NavProps> = (props) => {
  return (
    <NavUl alignItems="center" {...props}>
      {React.Children.map(props.children, child => (
        <NavLi>{child}</NavLi>
      ))}
    </NavUl>
  );
};

const NavCol: React.FC<NavProps> = (props) => {
  return (
    <NavUl flexDirection={'column'} {...props}>
      {React.Children.map(props.children, child => (
        <NavLi>{child}</NavLi>
      ))}
    </NavUl>
  );
};

export const NavBase = (props: NavProps) => {
  return (
    <NavRow {...props}>{props.children}</NavRow>
  );
};

export const Nav = withSchema(
  NavBase,
  {
    Row: NavRow,
    Col: NavCol,
  });
